import _objectSpread from "/Users/gg/mmp/Generali/20221219/generali/zuzahlungs-atlas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createClass from "/Users/gg/mmp/Generali/20221219/generali/zuzahlungs-atlas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/gg/mmp/Generali/20221219/generali/zuzahlungs-atlas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
var Input = /*#__PURE__*/_createClass(function Input(element, callback, options) {
  _classCallCheck(this, Input);
  this.element = element;
  this.callback = callback;
  this.options = _objectSpread({
    enable: true
  }, options);
});
export { Input as default };